import { graphql } from "../gql";

export const saveCasesAsQueueMutationDoc = graphql(`
  mutation saveCasesAsQueue($input: SaveCasesAsQueueInput!) {
    saveCasesAsQueue(input: $input) {
      ...AskAutodorQueueFragment
    }
  }
`);
